import { useMemo } from 'react';

import { useIsInsightsCampaignEnabled, useIsQuestionsOnlyMode } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useInsightsCampaignPageSettings: UseMainUIFeatureSettings<'insightsCampaignPage'> = (options) => {
  const insightsCampaignPageOverrides = options?.overrides?.insightsCampaignPage;

  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isInsightsCampaignsEnabled = useIsInsightsCampaignEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        ...insightsCampaignPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isInsightsCampaignsEnabled,
      ...insightsCampaignPageOverrides,
    };
  }, [insightsCampaignPageOverrides, isInsightsCampaignsEnabled, isQuestionsOnlyMode]);
};
